import React from 'react';
import { useFeedback } from '../../Data/Help';
import Button from '../../Components/Button/Button';

const Feedback = ({activityId, container, short}) => {
    const {feedback, giveFeedback, isLoading} = useFeedback(activityId);

    const buttons = <>
        <Button
            theme={feedback === -1 ? 'lightPrimary' : 'light'}
            loading={isLoading && feedback === -1}
            icon="ThumbsDown"
            iconTheme={feedback === -1 ? 'solid' : 'light'}
            label={short ? null : 'Not helpful'}
            onClick={() => giveFeedback(-1)}
        />
        <Button
            theme={feedback === 1 ? 'lightPrimary' : 'light'}
            loading={isLoading && feedback === 1}
            icon="ThumbsUp"
            iconTheme={feedback === 1 ? 'solid' : 'light'}
            label={short ? null : 'Helpful'}
            onClick={() => giveFeedback(1)}
        />
    </>;

    if (!container) {
        return buttons;
    }

    return <div className="flex justify-center gap-x-4 mt-4 w-full">
        {buttons}
    </div>
}

export default Feedback;